import React, {useEffect, useState } from 'react';
import {FIELD_DETAILS, PROJECT_NAME, REQUIRED, TITLE} from '../ISRConstants';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../Pages/DefineModel/model';
import ToggleButton from "../../../../Components/Common/components/Inputs/ToggleButton";
import { useCategoryUpdate } from './hooks/useCategoryUpdate';

type TCategoryComponentProps = {
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    indexInfo: TIndexState;
}

const CategoryComponent = ({selectedItem, setUserProjectDataModels, userProjectDataModels, indexInfo}: TCategoryComponentProps) => {
    const [fieldName, setFieldName] = useState<string>('');
    const { updateCategoryField } = useCategoryUpdate(selectedItem, userProjectDataModels, setUserProjectDataModels, indexInfo);

    useEffect(() => {
        const productCategory = selectedItem as TProductCategory;
        if (productCategory?.data?.belongsToDataModel ?? false) {
            setFieldName(userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data.productCategories[indexInfo?.categoryIndex ?? -1].data?.name ?? "");
        } else {
            setFieldName(userProjectDataModels?.project.productCategories[indexInfo?.categoryOutsideDataModelIndex ?? -1]?.data?.name ?? "");
        }
    }, [selectedItem, userProjectDataModels, indexInfo]);

    const handleCategoryNameChange = (value: string) => {
        setFieldName(value);
        updateCategoryField('name', value);
    };

    const handleRequiredChange = (value: boolean) => {
        updateCategoryField('required', value);
    };

    const productCategory = selectedItem as TProductCategory;

    return (
        <div className='cart-style-dm'>
            <label className='cart-title'>{FIELD_DETAILS}</label>
            <div className='tw-flex tw-items-center tw-mt-3'>
                <div className='tw-w-[60%] tw-pe-2'>
                    <label className='tw-text-sm tw-text-[#747593] tw-block'>{TITLE}</label>
                    <input 
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        value={fieldName}
                        onChange={(e) => handleCategoryNameChange(e.target.value)}
                        placeholder={PROJECT_NAME} />
                </div>
                <div className='tw-w-[40%] tw-ms-4'>
                    <label className='tw-text-sm tw-text-[#747593] tw-block tw-mb-2'>{REQUIRED}</label>
                    <ToggleButton
                        name="Required"
                        value={productCategory?.data?.required ?? false}
                        onChange = {(e) => handleRequiredChange(e.target.checked)} />
                </div>
            </div>
        </div>
    );
}

export default CategoryComponent;